/** Applies flat-list drag reorder via executeMoveTask (moveTask wrapper). */
import { computeFlatListDropOrderKey } from './flatListReorderCompute';

/**
 * @param {object} params
 * @param {Array<{ id: string, orderKey?: string }>} params.reorderList
 * @param {string} params.activeId
 * @param {string} params.overId
 * @param {{ id: string, orderKey?: string, date?: unknown, time?: unknown }} params.activeTask
 * @param {Map<string, { parentId?: string | null }>} [params.tasksMap]
 * @param {(id: string, fields: object, userId: string, task?: object) => void | Promise<void>} params.moveTask
 * @param {(id: string, fields: object, userId: string) => void | Promise<void>} [params.updateTask]
 * @param {string} params.userId
 */
export const applyFlatListReorderMove = ({
  reorderList,
  activeId,
  overId,
  activeTask,
  tasksMap,
  moveTask,
  updateTask,
  userId,
}) => {
  if (!moveTask || !userId || !activeTask) return;

  const datePayload = {};
  if (activeTask.date) {
    datePayload.date = null;
    datePayload.time = null;
  }

  const newOrderKey = computeFlatListDropOrderKey(
    reorderList,
    activeId,
    overId,
    activeTask,
    tasksMap,
  );

  if (Object.keys(datePayload).length > 0 && updateTask) {
    updateTask(activeId, datePayload, userId);
  }
  if (newOrderKey) {
    moveTask(activeId, { orderKey: newOrderKey }, userId, activeTask);
  }
};
